<template>
  <div class="container">
    <div class="search-page">
      <div class="search-page-header">
        <div class="search-page-sort-select">
          <b-form-select v-model="search.selectedSort" :options="sortOptions" class="mb-3" />
        </div>

        <div class="search-page-limit-select">
          <b-form-select v-model="page.limit" :options="optionsLimit" class="mb-3" />
        </div>

        <div class="search-page-pagination">
          <b-pagination
            align="right"
            size="md"
            :total-rows="page.count"
            v-model="page.current"
            :per-page="page.limit"
          ></b-pagination>
        </div>
      </div>

      <div
        class="search-page-filters"
        v-if="search.phrase || search.categoryList.length >0 || search.producerList.length > 0 || search.attributes.length > 0"
      >
        <div class="search-page-filters-title">Wybrane filtry</div>
        <div class="search-page-filters-content">
          <div v-if="search.phrase" class="filter" @click="removePhrase()">
            <span class="name">{{search.phrase}}</span>
            <span class="remove">x</span>
          </div>
          <div v-for="cat in search.categoryList" class="filter" @click="removeCategory(cat)">
            <span class="name">{{cat.name}}</span>
            <span class="remove">x</span>
          </div>
          <div v-for="brand in search.producerList" class="filter" @click="selectProducer(brand)">
            <span
              class="name"
              v-if="brands.list.find(b => b.id == brand).iphname"
            >{{ Cms.decode(brands.list.find(b => b.id == brand).iphname) }}</span>
            <span class="name" v-else>{{ Cms.decode(brands.list.find(b => b.id == brand).name) }}</span>
            <span class="remove">x</span>
          </div>

          <div v-for="attribute in search.attributes">
            <div
              v-for="value in attribute.values"
              class="filter"
              @click="selectFilter(attribute.name, value)"
            >
              <span class="name">{{ Cms.decode(value) }}</span>
              <span class="remove">x</span>
            </div>
          </div>
        </div>
      </div>

      <div class="search-page-searching" v-if="searching">
        <b-progress :value="100" variant="success" striped :animated="true" class="mb-2"></b-progress>
      </div>

      <div v-else-if="kindList == 'list'" class="row product-view-list">
        <div class="product-view-list-header">
          <div class="col-lg-1">Zdjęcie</div>
          <div class="col-lg-3">Nazwa</div>
          <div class="col-lg-2">Producent / symbol producenta</div>
          <div class="col-lg-2">Kod kreskowy</div>
          <div class="col-lg-1">Stan</div>
          <div class="col-lg-1 header-price">Cena</div>
          <div class="col-lg-2"></div>
        </div>

        <div v-for="product in products" class="product-item">
          <router-link
            class="product-item-image"
            :to="{ name: 'productPage', params:{id: product.id, slug: 'item'}}"
          >
            <img :src="product.image" :alt="product.name" class="img-fluid" />
          </router-link>
          <router-link
            class="product-item-name"
            :to="{ name: 'productPage', params:{id: product.id, slug: 'item'}}"
          >{{ Cms.decode(product.name) }}</router-link>

          <div class="product-item-producer">{{ Cms.decode(product.producer) }}</div>
          <div class="product-item-producer-code">{{product.SYMBOL_PRODUCENTA}}</div>
          <div class="product-item-ean">
            <barcode :value="product.ean" format="EAN13" width="1" height="60"></barcode>
          </div>

          <!-- <div v-if="demo" :class="[search.kindList == 'list' ? 'product-item-demo' : 'product-item-demo product-item-demo-gallery']"> -->
          <div
            v-if="demo"
            class="product-item-demo"
          >Zaloguj się żeby zobaczyć informacje o produkcie!</div>

          <div class="product-item-stock" v-if="!demo">
            <span v-if="product.stock > 0">
              {{product.stock}}
              <span class="unit">{{product.unit}}</span>
            </span>
            <span v-else-if="purchaseOverbookedProducts">zamów</span>
            <span v-else>brak</span>
          </div>
          <div
            v-if="(product.stock > 0 || purchaseOverbookedProducts) && !demo"
            class="product-item-price"
          >
            <span v-if="userSettings.B2B_CLIENT_PRICE_TYPE == 'net'">cena netto</span>
            <span v-else>cena brutto</span>
            <span class="price">{{ clientPrice(product) }}</span>
            <div class="discount" v-if="discountPrice(product) > 0">
              <label>cena katalogowa</label>
              <span class="before-price">{{ netPrice(product) }}</span>
              <span class="discount-percent">Rabat: {{ discountPrice(product) }} %</span>
            </div>
          </div>

          <div
            v-if="(product.stock > 0 || purchaseOverbookedProducts) && !demo"
            class="product-item-action"
          >
            <div class="button basket-button-active" @click="addToBasket(product)">
              <span class="button-text">Dodaj do koszyka</span>
              <cart-plus-icon title="dodaj do koszyka" />
            </div>
            <div v-if="offerEnable" class="button" @click="addToOffer(product)">
              <span class="button-text">Dodaj do oferty</span>
              <book-plus-icon title="dodaj do oferty" />
            </div>
          </div>
          <div v-else-if="purchaseInaccessibleProducts" class="product-item-inaccessible">
            <div class="button" @click="addToBasket(product)">
              <span class="button-text">Zapytaj opiekuna handlowego</span>
              <help-box-icon title="dodaj do koszyka" />
            </div>
          </div>
          <div v-else class="item-missing">
            <span v-if="!demo">Skontaktuj się z nami!</span>
          </div>
        </div>
      </div>

      <div v-else-if="kindList == 'gallery'" class="row product-list-gallery">
        <div
          v-for="product in products"
          class="col-12 col-md-6 col-lg-4 col-xl-3 product-list-item"
          :class="{'product-item-inaccessible': product.stock === 0}"
          v-if="!product.isGratis"
        >
          <div class="product-list-item-content">
            <div class="row product-item-main">
              <router-link :to="{ name: 'productPage', params:{id: product.id, slug: 'item'}}">
                <img
                  :src="product.image"
                  :alt="product.name"
                  class="img-fluid product-search-image my-2"
                />
                <p class="my-2 product-item-name">{{ Cms.decode(product.name) }}</p>
              </router-link>
            </div>
            <!-- <div class="row attributes">
              <div class="col-lg-12 attribute">
                Stan:
                <span v-if="product.stock>0">{{product.stock}}</span>
                <span v-else >brak</span>
              </div>
              <div class="col-lg-12 attribute">
                Producent: <span>{{Cms.decode(product.producer) }}</span>
              </div>
              <div class="col-lg-12 attribute">
                Symbol producenta: <span>{{ product.SYMBOL_PRODUCENTA }}</span>
              </div>
            </div>-->
            <div class="row">
              <div class="col-12">
                <div class="row values mx-auto" v-if="product.stock > 0">
                  <div v-if="product.beforePrice > 0" class="row search-before-price">
                    <div
                      class="before-price col-lg-7"
                    >{{ String(calculateNetPrice(product.beforePrice, product.tax)).replace('.',',')}} PLN netto</div>
                    <div
                      class="discount-value col-lg-5"
                    >{{ calculateDiscount(parseFloat(calculateClientPrice(product.clientPrice, product.tax, 'net', userSettings, currency(), 'mainPage').replace(' PLN', '').replace(',', '.')), calculateNetPrice(product.beforePrice, product.tax))}}%</div>
                  </div>

                  <div class="prices">
                    <div class="row search-net-price">
                      <div class="price col-12">
                        <span
                          class="text-center"
                        >{{ calculateClientPrice(product.clientPrice, product.tax, 'net', userSettings, currency(), 'mainPage')}} netto</span>
                      </div>
                    </div>

                    <div class="row search-gross-price">
                      <div class="price-grey text-center col-12">
                        <span
                          class="text-center"
                        >{{ String(calculateGrossPrice(product.clientPrice, product.tax, 'mainPage').toFixed(2)).replace('.',',')}} brutto</span>
                      </div>
                      <div class="col-12">
                        <span class="text-center product-item-unit">{{product.unit.toLowerCase()}}</span>
                      </div>
                    </div>
                  </div>
                  <div v-if="product.gratis.length > 0" class="product-item-gratis">
                    <div v-if="product.gratis.length === 1" class="alert alert-success mt-1">
                      <img
                        src="./../../assets/icons/info.svg"
                        alt="Info Icon"
                        style="width: 1.2rem; height: 1.2rem;"
                        class="mr-1"
                      />
                      Przy zakupie tego produktu otrzymasz gratis!
                    </div>
                    <ul v-else-if="product.gratis.length > 1" class="alert alert-success">
                      Przy zakupie:
                      <li v-for="gratis in product.gratis">
                        <span>{{gratis.Rangefrom}} - {{gratis.Rangeto}}</span>
                        sztuk otrzymujesz
                        <span>{{gratis.Gratiscount}}x gratis</span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div v-else>
                  <div class="text-secondary">
                    <h6>Brak produktu</h6>
                  </div>
                </div>
              </div>
              <div class="col-12 product-basket-container">
                <div v-if="product.stock >= 1" class="col-lg-6 buttons mx-auto mt-1">
                  <!-- <div :class="[product.stock>0 ? 'button basket-button-active' : 'button basket-button-inactive']" @click="addToBasket(product)"> -->
                  <div class="basket-button-active" @click="addToBasket(product)">
                    <!-- <cart-plus-icon title="dodaj do koszyka" /> -->
                    <img src="../../assets/shopping-cart-green.svg" alt />
                  </div>
                  <!--
                  <div class="button">
                    <calculator-icon title="dodaj do oferty" />
                  </div>
                  -->
                </div>
                <div v-else class="col-lg-6 buttons basket-button-inactive mx-auto mt-1">
                  <img src="../../assets/shopping-cart-gray.svg" alt />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="search-page-header">
        <div class="search-page-pagination">
          <b-pagination
            align="right"
            :total-rows="page.count"
            v-model="page.current"
            :per-page="page.limit"
          ></b-pagination>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapState, mapGetters } from "vuex";
import VueBarcode from "vue-barcode";

import {
  BPagination,
  BProgress,
  BFormSelect,
  BFormCheckbox
} from "../BootstrapElements";

import SearchOptions from "./SearchOptions.vue";

import { Cms } from "../RedbayComponents";
import Product from "./../products/src/product/Product";
import CalculatePrice from "../products/src/product/CalculatePrice";
import ViewListIcon from "vue-material-design-icons/ViewList.vue";
import ViewModuleIcon from "vue-material-design-icons/ViewModule.vue";
import SortAscendingIcon from "vue-material-design-icons/SortAlphabetical.vue";
import SortDescendingIcon from "vue-material-design-icons/SortDescending.vue";
import CartIcon from "vue-material-design-icons/Cart.vue";
import CartPlusIcon from "vue-material-design-icons/CartPlus.vue";
import CalculatorIcon from "vue-material-design-icons/Calculator.vue";
import Adjust from "vue-material-design-icons/Adjust.vue";
import SortAlphabetical from "vue-material-design-icons/SortAlphabetical.vue";
import SortNumeric from "vue-material-design-icons/SortNumeric.vue";
import BookPlusIcon from "vue-material-design-icons/BookPlus.vue";
import HelpBoxIcon from "vue-material-design-icons/HelpBox.vue";
import { debug } from "util";

export default {
  components: {
    barcode: VueBarcode,
    CalculatorIcon,
    CartPlusIcon,
    CartIcon,
    SortDescendingIcon,
    SortAscendingIcon,
    ViewModuleIcon,
    ViewListIcon,
    Adjust,
    SortAlphabetical,
    SortNumeric,
    BPagination,
    BProgress,
    BFormSelect,
    BFormCheckbox
  },
  data() {
    return {
      searching: false,
      products: [],
      kindList: "gallery",
      optionsLimit: [],
      producers: [],
      filters: {
        attributes: []
      },
      // available:true,
      Cms: Cms,
      sortOptions: [
        { value: "priority", text: "--- wybierz ---" },
        { value: "priceAsc", text: "od najniższej ceny " },
        { value: "priceDesc", text: "od najwyższej ceny " },
        { value: "nameAsc", text: "po nazwie rosnąco" },
        { value: "nameDesc", text: "po nazwie malejąco" },
        { value: "quantityAsc", text: "od najmniejszej ilości" },
        { value: "quantityDesc", text: "od największej ilości" }
      ]
    };
  },

  computed: {
    ...mapState({
      search: state => state.search,
      reload: state => state.search.reload,
      limit: state => state.search.page.limit,
      current: state => state.search.page.current,
      page: state => state.search.page,
      sort: state => state.search.selectedSort,
      userSettings: state => state.user.userSettings,
      brands: state => state.brands,
      available: state => state.search.available,
      demo: state => state.demo.enabled,
      prices: state => state.user.userPrices
    }),
    ...mapGetters({
      currency: "company/selectedCurrency"
    })
  },
  watch: {
    reload: function() {
      this.findResults();
    },
    current: function() {
      this.findResults();
    },
    limit: function() {
      this.findResults();
    },
    sort: function() {
      this.findResults();
    },
    kindList: function(value) {
      window.localStorage.setItem("View-Type", value);
    },
    available: function() {
      this.$store.dispatch("search/reload");
    },
    prices: function() {
      this.$store.dispatch("search/reload");
    }
  },

  methods: {
    ...CalculatePrice(),

    quantitySortHandler() {
      if (this.search.selectedSort === "quantityAsc") {
        this.search.selectedSort = "quantityDesc";
      } else if (this.search.selectedSort === "quantityDesc") {
        this.search.selectedSort = "quantityAsc";
      } else {
        this.search.selectedSort = "quantityAsc";
      }
    },

    nameSortHandler() {
      if (this.search.selectedSort === "nameAsc") {
        this.search.selectedSort = "nameDesc";
      } else if (this.search.selectedSort === "nameDesc") {
        this.search.selectedSort = "nameAsc";
      } else {
        this.search.selectedSort = "nameAsc";
      }
    },

    async findResults() {
      if (!this.searching) {
        let group = this.userSettings["USER_GROUP"]
          ? this.userSettings["USER_GROUP"]
          : 0;
        this.searching = true;
        let results = await this.$store.dispatch(
          "search/requestData",
          this.filters
        );
        this.searching = false;
        this.products = results.documentList.map(pr =>
          Product.buildProduct(
            pr,
            this.$config.get("searchPage.visibleAttributes"),
            this.prices,
            group
          )
        );
        this.$store.state.search.page = results.page;

        this.$store.dispatch(
          "brands/setFilters",
          Product.buildFilter(results, "Producer")
        );
        this.$store.dispatch(
          "categories/setFilters",
          Product.buildFilter(results, "Category")
        );
        this.$store.dispatch(
          "search/setBuiltFilters",
          this.filters.attributes
            .map(f =>
              Object.create({
                name: f.name,
                values: Product.buildFilter(results, f.name)
              })
            )
            .filter(f => f.values.length > 0)
        );
      }
    },

    async addToBasket(product) {
      await this.$store.dispatch("basket/addToBasket", {
        id: product.variantId,
        cart_quantity: 1
      });
      this.$store.dispatch("openRightWindow");
    },

    selectProducer(id) {
      let index = this.search.producerList.indexOf(id);
      if (index > -1) {
        this.search.producerList.splice(index, 1);
      } else {
        this.search.producerList.push(id);
      }
      this.$store.dispatch("search/selectedProducer", this.search.producerList);
      this.$router.replace({ name: "searchPage" });
    },

    selectFilter(name, value) {
      let attribute = this.search.attributes.find(a => a.name == name);
      if (!attribute) {
        attribute = { name: name, values: [] };
        this.search.attributes.push(attribute);
      }
      let index = attribute.values.indexOf(value);
      if (index > -1) {
        attribute.values.splice(index, 1);
      } else {
        attribute.values.push(value);
      }
      this.$store.dispatch("search/reload");
    },

    changeAvailable() {
      this.search.available = !this.search.available;
      this.$store.dispatch("search/reload");
    },

    removeCategory(category) {
      let index = this.search.categoryList.indexOf(category);
      if (index > -1) {
        this.search.categoryList.splice(index, 1);
      }
      this.search.reload++;
    },

    removePhrase() {
      this.search.phrase = "";
      this.$store.dispatch("search/findByPhrase");
    }
  },

  async beforeMount() {
    if (!this.$store.state.user.authorizedUser) {
      this.$router.replace({ name: "mainPage" });
    }
    await this.$store.dispatch("user/getUserSettings");
    this.optionsLimit = this.$config.get("searchPage.optionsLimit");
    this.filters = this.$config.get("searchPage.filters");
    this.findResults();
    this.kindList = window.localStorage.getItem("View-Type")
      ? window.localStorage.getItem("View-Type")
      : "gallery";
  }
};
</script>



// WEBPACK FOOTER //
// src/components/template/SearchPage.vue